export default "__VITE_ASSET__BrBoiBj3__"